import { UIState } from "./types";

export const state: UIState = {
  notifications: [],
  isNavOpen: false,
};
